import React from "react";
const MINI = [{
  initials: "MR",
  quote: "Empecé a vender pizzas el jueves. El viernes ya tenía 8 pedidos confirmados con seña.",
  who: "Marcela R., Gran Buenos Aires"
}, {
  initials: "JP",
  quote: "El Tomo de Ghost Kitchen me cambió todo. Mis smash burgers se agotan cada fin de semana.",
  who: "Juan P., Córdoba"
}, {
  initials: "SV",
  quote: "Los scripts de WhatsApp son oro puro. Antes no sabía cómo pedir la seña. Ahora cierro casi todos los pedidos.",
  who: "Sofía V., Rosario"
}];
export function MiniTestimonials() {
  return <section className="bg-black py-10 px-4" data-id="element-179" data-mp="12k49sfjfrrqv">
      <div className="max-w-6xl mx-auto grid gap-4 md:grid-cols-3" data-id="element-180" data-mp="1g9fw5jhor1k8">
        {MINI.map(t => <figure key={t.initials} className="bg-neutral-950 border border-neutral-800 rounded-xl p-5" data-id="element-181" data-mp="1bizflqikiztn">
            <div className="flex items-center gap-3 mb-3" data-id="element-182" data-mp="ntdegximyaj0">
              <div className="w-10 h-10 rounded-full bg-[#e10600] flex items-center justify-center font-display text-white text-sm" data-id="element-183" data-mp="nrk9dmno7yd4">
                {t.initials}
              </div>
              <span className="text-yellow-400 text-sm" data-id="element-184" data-mp="1ydfmw48biw8">⭐⭐⭐⭐⭐</span>
            </div>
            <blockquote className="text-neutral-200 text-sm leading-relaxed" data-id="element-185" data-mp="6xgefytm8svr">"{t.quote}"</blockquote>
            <figcaption className="text-neutral-500 text-xs mt-3" data-id="element-186" data-mp="bpzoilt3h5vt">— {t.who}</figcaption>
          </figure>)}
      </div>
    </section>;
}